import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import { getSubscriberList, updateSubscriberStatus } from '../../actions/users';
import ReactHtmlParser from 'react-html-parser';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"

const SubscriberList = () => {
	const [userdet, setUser] = useState();
	const [exportdata,setExportdata]=useState([]);

    useEffect(() => {
		getSubList();
	}, []);
    const getSubList = async () => {
		var subscriberData = await getSubscriberList();
		if (subscriberData.Success) {
			setUser(subscriberData.data);
			
    var ddd= subscriberData.data.map(({_id,__v,created,id,maySent,...rest})=>{
        return rest
    })
    setExportdata(ddd)
            }	
            else
			toastAlert('error', "Error on Server");
	}
    const handleChangemaysent = async (event) => {
		let {id , checked} = event.target;
		let handlemaychange = await updateSubscriberStatus({email : id , maySentChecked : checked});
		if (handlemaychange.Success) {
			toastAlert('success','Success...Please wait for data refresh');
			setTimeout(()=>{
				window.location.reload();
			},2000)
		}
		else{
			toastAlert('error','Error on Server');
		}
	}

  const add = async () => {
		window.location = "/subscriberadd";
	}

    const columns = [
		{
			key: "ind",
			text: "SNO",
			className: "name",
			align: "center",
			sortable: false,
			cell: (row, index, column, id) => <p className='text-center exchange_table_values'>{index + 1}</p>,
		  },
		{
			key: "email",
			text: "Email",
			className: "email",
			align: "center",
			sortable: false,
			cell: record =>
				<p className='text-center exchange_table_values'>{ReactHtmlParser(record.email)}</p>
		},

		{
			key: "action",
			text: "Action",
			className: "action",
			width: 100,
			align: "center",
			sortable: false,
			cell: record => {
				return (
					<div className='text-center exchange_table_values'>
						{record && <input type="checkbox" name={record._id} id={record.email} checked={record.maySent} onChange={(event) =>{ handleChangemaysent(event)}}/>}
					</div>
				);
			}
		},
	];

    const config = {
      page_size: 5,
      length_menu: [10, 20, 50],
      filename: "Users",
      no_data_text: "No user found!",
  
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: <> Previous </>,
          next: <>Next</>,
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
      defaultSortAsc: true,
    };
    
    return (
        <>
          <Container fluid className="common_bg position-relative">
            <div className="liner"></div>
            <Row>
              <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                <Sidebar />
              </Col>
              <Col  xl={10} lg={12}>
                <Header title={'Subscriber Lists'}/>
    
                <div className="common_page_scroller mt-5 pe-2">
                <div className="page_header">
            <h2>Subscriber List</h2>
            <div>
              <div className="selection_sec">
                <button type='button' onClick={add}>SEND NEWS LETTER</button>
              </div>
    
            </div>
          </div>
                  <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                    <ReactDatatable
                      config={config}
                      records={userdet}
                      columns={columns}
                    />
                  </div>
                </div>
                <div className='bottom_btn_comp'>
                  <Exportexcel excelData={exportdata} fileName={'subscribers'} />
                  <Exportpdf pdfData={exportdata} fileName={'subscribers'} />
                  <Exportcsv csvData={exportdata} fileName={'subscribers'} />
                </div>
              </Col>
            </Row>
          </Container>
        </>
      )
}

export default SubscriberList